import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faCheckSquare, faCoffee,faUser,faEnvelope,faLock,faClock } from '@fortawesome/free-solid-svg-icons'

library.add(fab, faCheckSquare, faCoffee,faUser,faEnvelope,faLock,faClock)
